<template>
    <div v-if="currentMetal">

        <h1 class="font-active mb-3">{{currentCarat.product_name}}</h1>

        <div class="price_box">
            <div class="price_igi">
                <h2 class="">
                    {{ $formatPrice(currentCarat.price) }}
                    <span v-if="!$country.is_india" class="ms-2">{{ $formatPrice(currentCarat.mrp) }}</span>
                </h2>
                <div class="igi_block" v-if="['IGI', 'igi'].includes(detailData.lab)">
                    <img width="30" height="30" src="https://assets.friendlydiamonds.com/fdl/fd_gif/diamond.gif" alt="">
                    <span>IGI Certified</span>
                </div>
            </div>
        </div>

        <div class="d-flex mt-2 w-100" v-if="!$country.is_india">
            <div v-if="currentCarat.discount_label" class="disc_chip_pdp">{{ currentCarat.discount_label }}% OFF</div>
            <p v-if="currentCarat.lowest_price_label && currentCarat.discount_label" class="lowest_price_pdp">Lowest Price Ever</p>
        </div>

        <div class="affirm_info" v-if="$country.affirm">
            <p class="affirm-as-low-as mb-0 mt-2" data-page-type="diamond" :data-amount="currentCarat.price * 100"></p>
        </div>

        <div class="mb-3"  v-if="$country.expedite">
            <CommonChristmasExpediteDelivery :locale="$i18n.locale" />
        </div>
         <!-- settings -->
        <div class="prod_list_box">
            <div class="prod_list_img">
                <SvgStepsSvg v-if="detailData.sub_type === 'in-stock-ring'" :type="'ring_setting'" />
                <SvgStepsSvg v-if="detailData.sub_type === 'in-stock-earring'" :type="'earring_setting'" />
                <SvgStepsSvg v-if="detailData.sub_type === 'in-stock-pendant'" :type="'pendant_setting'" />
            </div>
            <div class="prod_list_detail">
                <p class="mb-1 font-active"><span> {{ detailData.product_name }} </span>  </p>
                <h5 class="">{{ detailData.metal_label }}</h5>
            </div>
        </div>

        <!-- diamond -->
        <div class="prod_list_box" v-if="detailData.sub_type === 'in-stock-earring'">
            <div class="prod_list_img">
                <SvgStepsSvg :type="'earring_diamond'" />
            </div>
            <div class="prod_list_detail">
                <p class="mb-1 font-active"><span> {{detailData.stone_one_weight}} Ct. {{ detailData.stone_one_shape }} Lab Grown Diamond </span>  </p>
                <h5 class="">Color: {{ detailData.stone_one_color }}  |  Clarity: {{ detailData.stone_one_clarity }}  |   Lab: {{ detailData.stone_one_lab }}</h5>
            </div>
        </div>
        <div class="prod_list_box" v-else>
            <div class="prod_list_img">
                <SvgShapeSvg :type="detailData.stone_one_shape.toLowerCase()" />
            </div>
            <div class="prod_list_detail">
                <p class="mb-1 font-active"><span> {{detailData.stone_one_weight}} Ct. {{ detailData.stone_one_shape }} Lab Grown Diamond </span>  </p>
                <h5 class="">Color: {{ detailData.stone_one_color }}  |  Clarity: {{ detailData.stone_one_clarity }}  |   Lab: <a target="_blank" rel="nofollow noopener" :href="detailData.stone_one_cert_link">{{ detailData.stone_one_lab }}</a></h5>
            </div>
        </div>

        <!-- total carat -->
        <div class="prod_list_box">
            <div class="prod_list_img">
                <SvgStepsSvg v-if="detailData.sub_type === 'in-stock-ring'" :type="'ring_complete'" />
                <SvgStepsSvg v-if="detailData.sub_type === 'in-stock-earring'" :type="'earring_complete'" />
                <SvgStepsSvg v-if="detailData.sub_type === 'in-stock-pendant'" :type="'pendant_complete'" />
            </div>
            <div class="prod_list_detail">
                <p class="mb-1 font-active"><span> {{ detailData.lot_weight }} Ct. Total Carat Weight </span>  </p>
                <h5 class="">{{ detailData.stone_one_weight}} Ct Center Stone 
                    <span v-if="detailData.setting.side_lot_weight">+ ~ {{ detailData.setting.side_lot_weight  }} Ct. tw Accent Stones</span>
                </h5>
            </div>
        </div>

        <div class="my-4">
            <JewelryWebshopDropdown 
                v-if="detailData.sub_type === 'in-stock-ring'"
                :type="'size'" 
                attr="size"
                :label="'select ring size ('+sizeSelectCountry+')'" 
                :mode="errors.size"
                ref="viewerror"
                :fastShip="true"
            />

            <JewelryWebshopDropdown 
                v-if="detailData.sub_type === 'in-stock-pendant'"
                :type="'size'" 
                attr="chain_length"
                :label="'Chain Length'" 
                :mode="errors.chain_length"
                ref="viewerror"
                :fastShip="true"
            />

            <JewelryWebshopDropdown 
                v-if="detailData.sub_type === 'in-stock-earring'"
                :type="'size'" 
                attr="back_type"
                :label="'Back Type'" 
                :mode="errors.back_type"
                ref="viewerror"
                :fastShip="true"
            />
        </div>

        <div class="mt-2" v-if="$country.appraisal">
            <div class="check_band mb-4" v-if="currentMetal && detailData.sub_type != 'couple-bands-ring'">
                <div class="checkbox_custom ms-0" id="appraisal">
                    <div class="checkbox_custom_labels" @click="toggleAppraisal()">
                        <span :class="{ 'checked' : has_appraisal === 1,  'unchecked' : has_appraisal === 0 }"></span>
                        <label class="mb-0">Add an Appraisal Certificate (+ {{ $formatPrice(50) }}) </label>
                    </div>
                    <div class="tooltip_box">
                        <SvgHeaderSvg class="ms-1" :type="'info'" />
                        <div class="tooltip_text tooltip_text_mod">This document is usually required to apply for your {{ $t('jewelry') }} insurance after you recieve the item</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="my-4">
            <CommonEstimateDate :module_subtype="'shop'" :setting_id="currentCarat.id" :diamond_id="''" :size="currentActiveSize.value" />
        </div>

        <div class="my-4">
            <div class="quicker">
                <p class="mb-0">Want more choices? Dive into our <span @click="redirectQuickShip(false)">Full Catalog</span></p>
            </div>
        </div>

        <div class="select_btn_block">
            <div class="alert alert-info mb-0" role="alert" v-if="currentMetal.availability === 0 || currentCarat.availability === 0">
                *This item is no longer available
            </div>
            <div class="select_button" v-if="buttonLoader">
                <span>PLEASE WAIT...</span>
            </div>
            <div v-else @click="addToCart()" class="select_button">
                <div>add to bag</div>
            </div>
        </div>

        <div class="row my-4">
            <div class="col-lg-6 col-md-12 mb-3">
                <ModalDropHint :data="detailData" />
            </div>
            <div class="col-lg-6 col-md-12 mb-3">
                <ModalGemologist :data="detailData" />
            </div>
            <div class="col-12">
                <CommonFreeCartOffer v-if="$country.free_product" class="mt-2" />
            </div>

        </div>

    </div>
</template>

<script setup>
    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    const store = shopdetailStore()
    const viewerror = ref(null);
    const localePath = useLocalePath();
    const { $country, $formatPrice, $toast, $jewelryDetailGtag, $jewelryToCartGtag } = useNuxtApp()

    const router = useRouter()
    const route = useRoute()

    const has_appraisal = ref(0)
    const errors = ref({})
    const skeleton = ref(true)
    const buttonLoader = ref(false)

    const currentActiveSize = computed(() => {
        const size = store.getCurrentActive('size')
        if(size){
            return size
        }
        return ''
    }) 

    const sizeSelectCountry = computed(() => {
        if($country.is_india){
            return 'IN'
        }
        return 'US'
    })

    const detailData = computed(() => {
        return store.getDetailData
    })

    const currentMetal = computed(() => {
        return store.getCurrentActive('metal')
    })

    const currentCarat = computed(() => {
        const item = store.getCurrentActive('carat')
        
        if( import.meta.client && item !== null && window.affirm !== undefined ){
            nextTick(() => {
                window.affirm.ui.ready(() => {
                    window.affirm.ui.refresh();
                });
            });
        }
        if(import.meta.client && item !== null){
            $jewelryDetailGtag({ metal: currentMetal.value, carat: item })
        }

        return item 
    })
    const scrollToError = async () => {
        await nextTick();
        if (viewerror.value) {
            const dropdownEl = viewerror.value.$el || viewerror.value;
            dropdownEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    const isSizeSelected = computed(() => {
        return store.getCurrentActive( 'size' )
    })

    const isFastShip = computed(() => {

        return route.query.FastShip == 'true'
    })

    const hasInstockItem = computed(() => {
        const data = store.getInStockData('')
        return data.length > 0 
    })
  
    
    function redirectQuickShip(  ){
        router.push(detailData.value.full_catalog_url);
    }

    const addToCart = async () => {
        errors.value = {}
        
        let data = {
            item_id: store.getCurrentActive('carat')?.id,
            item_type: detailData.value.sub_type,
            has_appraisal : has_appraisal.value,
            size: '',
            back_type: '',
            chain_length: ''
        }

        const subtype = store.getProductSubtype('')

        if(detailData.value.sub_type === 'in-stock-ring'){
            data.size = store.getCurrentActive('size')?.value
        }
        if(detailData.value.sub_type === 'in-stock-earring'){
            data.back_type = store.getCurrentActive('size')?.value
        }
        if(detailData.value.sub_type === 'in-stock-pendant'){
            data.chain_length = store.getCurrentActive('size')?.value
        }
        
        //actual api call
        try{
            buttonLoader.value = true
            const res = await $fetch(useCountryPath("/shop/add/session"), {
                method: 'POST',
                body: data
            })
            if(res.success){

                $jewelryToCartGtag({ metal: currentMetal.value, carat: currentCarat.value })
                $toast('success', 'Congratulations!', 'Item added to cart.');
                setTimeout(()=>{
                    window.location.href = localePath( {path: '/cart'});
                    // this.$router.push(this.localePath('/cart')); 
                    // this.$store.dispatch('getCartCount');
                }, 1500);
                buttonLoader.value = false
            }
        } catch (err) {
                buttonLoader.value = false
                if (err.status === 422) {
                    errors.value = err.data.errors
                      await scrollToError(); 
                }
                if (err.status === 400) {
                    $toast('alert', 'Alert!', 'The cart cannot accommodate more than 10 products.');
                }
            }
    }
            
    function toggleAppraisal(){
        if(has_appraisal.value === 0){
            has_appraisal.value = 1
        }else{
            has_appraisal.value = 0
        }
    }

       
    onMounted(() =>{
        if( import.meta.client && currentCarat.value !== null && window.affirm !== undefined ){
            nextTick(() => {
                window.affirm.ui.ready(() => {
                    window.affirm.ui.refresh();
                });
            });
        }

        skeleton.value = false
    })
</script>

<style scoped>
h1{
    font-style: normal;
    font-size: 32px;
    color: #212529;
    text-transform: capitalize;
}
.price_box h2 {
   font-size: 24px;
    color: #212529;
    margin: 0;
    line-height: 1.2;
    font-weight: 600;
    display: flex;
    align-items: center;
}
.price_box h2 span {
    color: #909090;
    font-weight: 400;
    font-size: 18px;
    text-decoration: line-through;
}
.select_button {
    background: var(--green);
    color: #fff;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
.igi_block span {
    font-size: 12px;
    color: #606060;
    font-weight: 600;
}

.igi_block {
    background: #f5f5f5;
    display: flex;
    align-items: center;
    padding: 0 13px 0 8px;
    border-radius: 5px;
}
.price_igi {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
label{
    color: #353535;
    font-size: 14px;
    font-weight: 600;
}
.proceed_msg label {
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    color: #303030;
    display: block;
    padding-bottom: 8px;
}
.proceed_msg p {
    color: #606060;
    font-weight: 500;
}
.please_select .svg-head {
    height: 12px;
    width: 20px;
}
.please_select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    height: 44px;
    pointer-events: none;
    opacity: 0.5;
    border-radius: 8px;
}
.ship_date p {
    font-size: 14px;
    color: #212529;
    font-weight: 400;
}
.ship_date p span {
    color: var(--green);
    font-weight: 600;
}
.quicker p {
    color: #606060;
}
.quicker p span {
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}
.prod_list_box {
    display: flex;
    align-items: flex-start;
    border-bottom: 2px dashed #c4c4c4;
    padding: 25px 0;
}
.prod_list_img {
    width: 10%;
}
.prod_list_detail {
    width: 90%;
}
.prod_list_detail p span {
    font-size: 18px;
    color: #212529;
}

.prod_list_detail h5 {
    font-size: 16px;
    color: #606060;
}

@media(max-width: 1100px){
    h1{
        font-size: 26px;
        line-height: normal;
    }
}
@media(max-width: 992px){
    .tooltip_text.tooltip_text_mod {
        margin-left: -150px;
    }
}
@media(max-width: 950px){
    h1 {
        font-size: 26px;
    }
    .price_box h2 {
        font-size: 26px;
    }
}
@media(max-width: 767px){
    .price_igi {
        width: 100%;
    }
    .select_btn_block {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.15);
        padding: 13px;
        border-radius: 8px 8px 0 0;
        background: #fff;
        z-index: 9;
    }
    h1 {
        /* margin-top: 10%; */
        font-size: 24px;
    }
    .price_box h2 span {
        font-size: 16px;
    }
    
    .price_box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .price_box h2 {
        font-size: 20px;
    }
    .prod_list_detail p span {
        font-size: 16px;
    }
    .prod_list_detail h5 {
        font-size: 14px;
    }
    .tooltip_text.tooltip_text_mod {
        margin-left: -120px;
    }
}
</style>
